<app-shared-modal
  name="Draft an offer"
  size="small"
  [open]="open"
  (modalClose)="onCloseHandler()"
>
  <div class="offer-modal-content">
    <ul class="gap-4">
      <li>
        <app-shared-icon name="offer-percentage"></app-shared-icon>
        Enter your initial offer proposal. Remember, this is non-binding.
      </li>
      <li>
        <app-shared-icon name="offer-phone"></app-shared-icon>
        A Rebuilt team member will reach out to schedule a showing and answer
        any questions.
      </li>
      <li>
        <app-shared-icon name="offer-home"></app-shared-icon>
        After the showing, you will have an opportunity to finalize your offer.
      </li>
      <li>
        <app-shared-icon name="offer-paper"></app-shared-icon>
        Rebuilt will send a purchase agreement for eSignature at the agreed upon
        price and move forward with closing.
      </li>
    </ul>
    <form [formGroup]="offerForm" (ngSubmit)="submitHandler()">
      <app-shared-input
        prefix="$"
        [for]="'price'"
        [value]="offerForm.value.price"
        [focused]="focused === 'price'"
        [touched]="offerForm.get('price')?.touched"
        [errors]="offerForm.get('price')?.errors"
        [disabled]="loading"
      >
        <input
          formControlName="price"
          name="price"
          id="price"
          type="text"
          mask="separator.0"
          thousandSeparator=","
          inputmode="numeric"
        />
      </app-shared-input>
      <!-- <app-shared-input
        label="Type"
        [selector]="true"
        [for]="'type'"
        [value]="offerForm.value.type"
        [focused]="focused === 'type'"
        [touched]="offerForm.get('type')?.touched"
        [errors]="offerForm.get('type')?.errors"
        [disabled]="loading"
      >
        <mat-select formControlName="type">
          <mat-option [value]="'MLS'"> MLS </mat-option>
          <mat-option [value]="'VERBAL'"> Verbal </mat-option>
          <mat-option [value]="'WHOLESALER'"> Wholesaler </mat-option>
        </mat-select>
      </app-shared-input> -->
      <app-shared-input
        label="Financing type"
        [selector]="true"
        [for]="'financingType'"
        [value]="offerForm.value.financingType"
        [focused]="focused === 'financingType'"
        [touched]="offerForm.get('financingType')?.touched"
        [errors]="offerForm.get('financingType')?.errors"
        [disabled]="loading"
      >
        <mat-select formControlName="financingType">
          <mat-option [value]="'CASH'"> Cash </mat-option>
          <mat-option [value]="'HARD_MONEY'"> Hard money </mat-option>
          <mat-option [value]="'BANK_FINANCING'"> Bank financing </mat-option>
          <mat-option [value]="'SELLER_FINANCING'">
            Seller financing
          </mat-option>
        </mat-select>
      </app-shared-input>
      <app-shared-input
        label="Have you walked this property?"
        [selector]="true"
        [for]="'isShowing'"
        [value]="offerForm.value.isShowing"
        [focused]="focused === 'isShowing'"
        [touched]="offerForm.get('isShowing')?.touched"
        [errors]="offerForm.get('isShowing')?.errors"
        [disabled]="loading"
      >
        <mat-select formControlName="isShowing">
          <mat-option [value]="'YES'"> Yes </mat-option>
          <mat-option [value]="'NO'"> No </mat-option>
        </mat-select>
      </app-shared-input>

      <div class="mt-8">
        <app-shared-button [loading]="loading" theme="dark-blue"
          >Submit draft offer</app-shared-button
        >
      </div>
    </form>
    <div class="financing">
      <app-shared-icon name="offer-financing" [size]="30"></app-shared-icon>
      <span class="ml-3">
        Need financing? We got you covered! Call
        <a href="tel:6156191177"> (615) 619-1177</a>
        or
        <a href="https://www.rebuilt.com/lending" target="_blank">
          learn more about our custom lending options </a
        >.
      </span>
    </div>
  </div>
</app-shared-modal>
